export default "__VITE_ASSET__5fd16b96__"